import {
  Box, Fade, Slide,
} from '@mui/material';
import Footer from 'components/Layout/Footer';
import { HEADER_HEIGHT } from 'constants';
import React, {
  useContext,
  useEffect, useMemo, useState,
} from 'react';
import useIsDesktop from 'hooks/useIsDesktop';
import { historyData } from 'utils/history';
import TopAreaSpace from 'components/TopAreaSpace';
import { LayoutContext } from 'constants/contexts';
import Header from './Header';

function Layout({
  children,
  header = <Header />,
  footer = <Footer />,
  sidebar = null,
  isList = false,
  sidebarWidth = '370px',
  headerHeight = HEADER_HEIGHT,
  ...props
}) {
  const isDesktop = useIsDesktop();
  const { lastAction } = historyData.get();
  const [visible, setVisible] = useState(false);
  
  useEffect(() => {
    setTimeout(() => setVisible(true), 100);
  }, []);

  const contextValue = useMemo(() => ({
    headerHeight,
  }), [headerHeight]);

  function renderContent() {
    if (isDesktop) {
      return (
        <Box sx={{ paddingTop: `calc(${headerHeight}px + var(--gap-top))` }}>
          {children}
        </Box>
      );
    }
    return (
      <Slide direction={(lastAction === 'POP') || isList ? 'right' : 'left'} in={visible}>
        <div>
          <Fade in timeout={800}>
            <Box>
              {children}
            </Box>
          </Fade>
        </div>
      </Slide>
    );
  }

  function renderHeader() {
    const right = sidebar && isDesktop ? sidebarWidth : 0;
    return (
      <Box
        sx={{
          position: {
            xs: 'sticky',
            md: 'fixed',
          },
          top: 0,
          left: 0,
          right,
          zIndex: 10,
          borderRadius: 0,
          border: 'none',
        }}
        variant="outlined"
      >
        {header}
      </Box>
    );
  }

  if (sidebar && isDesktop) {
    return (
      <LayoutContext.Provider value={contextValue}>
        <div>
          <Box
            sx={{ marginRight: sidebarWidth }}
          >
            {renderHeader()}
            {renderContent()}
          </Box>
          <Box
            sx={{
              width: sidebarWidth,
              flexShrink: 0,
              position: 'fixed',
              right: 0,
              height: '100vh',
              display: 'flex',
              flexDirection: 'column',
              borderRadius: 0,
              top: 0,
              zIndex: 11,
            }}
          >
            {sidebar}
          </Box>
        </div>
      </LayoutContext.Provider>
    );
  }
  return (
    <LayoutContext.Provider value={contextValue}>
      {renderHeader()}
      {renderContent()}
      {!isDesktop && footer }
    </LayoutContext.Provider>

  );
}

Layout.Header = Header;
Layout.Footer = Footer;
Layout.useHeaderHeight = () => {
  const { headerHeight } = useContext(LayoutContext);
  return headerHeight;
};

export default Layout;
